export default __webpack_public_path__ + "static/media/game_cloud.e199cbbe.jpg";